import { render, staticRenderFns } from "./TraderStats.vue?vue&type=template&id=a1ea2884&"
import script from "./TraderStats.vue?vue&type=script&lang=js&"
export * from "./TraderStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports